import Swal from 'sweetalert2'
import {
    CREATE_STORE_SUCCESS,
    CREATE_STORE_ERROR,
    CREATE_WAREHOUSE_LOADING,
    DELETE_WAREHOUSE,
    ERROR_DELETE_WAREHOUSE,
    LOADING_DELETE_WAREHOUSE,
    LOADING_ALL_WAREHOUSE,
    GET_ALL_WAREHOUSE,
    ERROR_ALL_WAREHOUSE,
    GET_ONLY_ONE_WAREHOUSE,
    ERROR_ONLY_ONE_WAREHOUSE,
    UPDATE_WAREHOUSE,
    LOADING_UPDATE_WAREHOUSE,
    ERROR_UPDATE_WAREHOUSE,
    LOADING_ONLY_ONE_WAREHOUSE
} from './types'

import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,

})
export const createWareHouse = (data) => async dispatch => {
    dispatch({
        type: CREATE_WAREHOUSE_LOADING
    });
    await fetch(`${urlServer}warehouses/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: data
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            if (respJson.success === true) {
                dispatch({
                    type: CREATE_STORE_SUCCESS
                });

                Toast.fire({
                    icon: 'success',
                    title: 'Almacén creado correctamente'
                })
            } else {
                dispatch({
                    type: CREATE_STORE_ERROR,
                    //payload: actionAward
                });

                if (respJson.error.code === 11000) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Ya exite almacén con ese nombre'
                    })
                }
                if (respJson.error.error.code === "MSJ003") {
                    Toast.fire({
                        icon: 'error',
                        title: 'Ya exite almacén con ese correo'
                    })
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'Error al crear'
                    })
                }

            }
        }).catch((error) => {
            console.log();
          });

}

export const getAllWareHouses = (name="",token) => async dispatch => {

    dispatch({
        type: LOADING_ALL_WAREHOUSE
    });
    await fetch(`${urlServer}warehouses/get-all`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${token ? token : inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
             body: JSON.stringify({
                textString : name ? name: ''
        }) 
    })
        .then(response => response.json())
        .then(respJson => {
            if (!respJson.success) {
                // eslint-disable-next-line no-throw-literal
                throw `Error al traer los datos ${respJson.error}`
            }
            if (!respJson.success) {
                dispatch({
                    type: ERROR_ALL_WAREHOUSE
                    //payload: actionAward
                });
            }else{
                dispatch({
                    type: GET_ALL_WAREHOUSE,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            dispatch({
                type: ERROR_ALL_WAREHOUSE
                //payload: actionAward
            });
            console.log()
        })

}
export const deleteWareHouse = (id) => async dispatch => {
    dispatch({
        type: LOADING_DELETE_WAREHOUSE
    });
    await fetch(`${urlServer}warehouses/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            warehouseId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: DELETE_WAREHOUSE,
                payload: { id }
            });
            dispatch({
                type: ERROR_DELETE_WAREHOUSE,
                //payload: actionAward
            });
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Almacén Eliminado Correctamente'
                })
            } else {
                Toast.fire({
                    icon: 'error',
                    title: 'Error al Eliminar'
                })
            }
        })
        .catch(error => {
            console.log()
        })
}

export const updateWareHouse = (values, id,history) => async dispatch => {
    dispatch({
        type: LOADING_UPDATE_WAREHOUSE
    });
    await fetch(`${urlServer}warehouses/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
       //     'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: values
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: UPDATE_WAREHOUSE,
                payload: { data: respJson.data }
            });
            dispatch({
                type: ERROR_UPDATE_WAREHOUSE,
                //payload: actionAward
            });
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Almacén Actualizado Correctamente'
                })
                history.push("/Admin/Inventory/WareHouseAdmin")
            } else {
                Toast.fire({
                    icon: 'error',
                    title: 'Error al Actualizar'
                })
            }
        })
        .catch(error => {
            console.log()
        })
}
export const getOneWareHouseById = (id) => async dispatch => {
    dispatch({
        type: LOADING_ONLY_ONE_WAREHOUSE
    });
    await fetch(`${urlServer}warehouses/get-one-by-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            warehouseId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: GET_ONLY_ONE_WAREHOUSE,
                payload: { data: respJson.data }
            });
            dispatch({
                type: ERROR_ONLY_ONE_WAREHOUSE,
                //payload: actionAward
            });
        })
        .catch(error => {
            console.log()
        })
}

export const findWareHousesByName = (name) => async dispatch => {
    dispatch({
        type: LOADING_ALL_WAREHOUSE
    });
    await fetch(`${urlServer}warehouses/get-all`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
         body: JSON.stringify({
            textString : name
        }) 
    })
        .then(response => response.json())
        .then(respJson => {
            if (!respJson.success) {
                dispatch({
                    type: ERROR_ALL_WAREHOUSE
                    //payload: actionAward
                });
            }else{
                dispatch({
                    type: GET_ALL_WAREHOUSE,
                    payload: respJson.data
                });
            }
            
        })
        .catch(error => {
            dispatch({
                type: ERROR_ALL_WAREHOUSE
                //payload: actionAward
            });
            console.log()
        })
}